import requestApi from '../../../apirest';
import { apiURL } from '../../../apirest/getAPIURL';

// Catálogo completo de produtos — usado tanto para exibir a contagem em
// estoque quanto para alimentar a busca por produto nas telas de Facebook
// e Google.
export async function fetchProducts() {
  const response = await requestApi('/products', {}, 'get');
  return response.data.doc;
}

// Sincroniza um único produto com o catálogo do Facebook/Instagram Shopping.
export async function syncFacebookProduct(code) {
  const response = await requestApi(
    '/services/facebook/syncronizeCatalog',
    { code },
    'post'
  );
  return response.data;
}

// Sincroniza um único produto com o Google Shopping.
export async function syncGoogleProduct(code) {
  const response = await requestApi(
    '/services/shopping/syncronizeGoogleShopping',
    { code },
    'post'
  );
  return response.data;
}

// Contagem de produtos/linhas que serão exportados para a planilha do
// TikTok Shop.
export async function fetchTikTokExportCount() {
  const response = await fetch(`${apiURL}/tiktok/export/count`);
  if (!response.ok) {
    throw new Error(`Erro ${response.status}`);
  }
  return response.json();
}

// Planilha (.xlsx) no formato de importação em massa do TikTok Shop.
export async function downloadTikTokExportXlsx() {
  const response = await fetch(`${apiURL}/tiktok/export/xlsx`);
  if (!response.ok) {
    throw new Error(`Erro ${response.status}`);
  }
  return response.blob();
}
